// Aetheris Labs — Privacy Policy shown at checkout and in the footer.

export const PRIVACY_SECTIONS = [
  {
    title: "Who We Are",
    body: `Aetheris Labs ("we", "us", "our") operates this website and sells laboratory research compounds. This Privacy Policy explains what personal data we collect, why we collect it, how we use and protect it, and the choices you have. All products are sold strictly for laboratory research use only and are not for human or veterinary consumption.`,
  },
  {
    title: "Data We Collect",
    body: `Account data: when you register, we store your name, email address and a securely hashed password, along with your research-use and age confirmation.

Order data: when you place an order we collect your billing/shipping details (name, company, address, country, postcode), email address, industry/profession, order contents and your acceptance of our Terms & Conditions.

Saved addresses: if you choose, we store shipping addresses to your account for faster checkout.

Payment data: payments are made in Bitcoin directly to our wallet address or via PayPal. We never see, collect or store your card details, bank details or wallet keys. For Bitcoin payments, the on-chain transaction ID is public blockchain data that may be linked to your order.

Usage data: we may collect standard technical data such as IP address, browser type and pages visited, used for security (including brute-force login protection) and to keep the site running.`,
  },
  {
    title: "How We Use Your Data",
    body: `Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in this privacy policy, including:

- Processing, fulfilling and shipping your orders, and contacting you about them
- Detecting payment on-chain and marking your order paid
- Maintaining your account and saved addresses
- Sending order confirmations and service emails
- Preventing fraud, abuse and unauthorized access
- Meeting legal, tax and regulatory obligations

We do not sell your personal data to anyone.`,
  },
  {
    title: "Cookies",
    body: `We use a small number of strictly necessary cookies: secure, httpOnly authentication cookies that keep you signed in. We do not use advertising or third-party tracking cookies.`,
  },
  {
    title: "Third Parties",
    body: `We share data only with the providers needed to run the store: our email delivery provider (to send order confirmations and notifications), payment networks (the public Bitcoin blockchain; PayPal if you choose it at checkout), and shipping carriers (delivery address only). Each provider processes data under its own privacy terms.`,
  },
  {
    title: "Data Retention",
    body: `We keep order records as required for accounting, tax and legal purposes. Account data is kept until you ask us to delete it. You may delete saved addresses from your account at any time.`,
  },
  {
    title: "Security",
    body: `Passwords are stored only as salted bcrypt hashes. Sessions use secure, httpOnly cookies. Access to order and customer data is restricted to authorized administrators. No method of transmission or storage is 100% secure, but we apply industry-standard safeguards appropriate to the data we hold.`,
  },
  {
    title: "Your Rights",
    body: `You may request a copy of the personal data we hold about you, ask us to correct or delete it, or close your account entirely, by contacting us. Deleting your account removes your login and saved addresses; order records may be retained where the law requires.`,
  },
  {
    title: "Age & Research-Use Restriction",
    body: `This website and its products are intended only for persons 21 years or older purchasing for legitimate laboratory research. We do not knowingly collect data from anyone under 21.`,
  },
  {
    title: "Changes to This Policy",
    body: `We may update this policy from time to time. The version date below reflects the latest revision; continued use of the website after changes constitutes acceptance.`,
  },
  {
    title: "Contact",
    body: `For any privacy question or request, contact us through the website. We aim to respond within 72 hours.`,
  },
];

export const PRIVACY_VERSION = "2026-09-27";
